module.exports = Promise.all([import("angular"), import("utils/truncate"), import("utils/escape-html")]).then(deps => {
    let [angular, truncate, EscapeHtml] = deps;
    truncate = truncate.default;
    EscapeHtml = EscapeHtml.default;

    var app = angular.module("tapFilters", []);

    app.filter("tapCurrency", function() {
        return function(amount, shortcode) {
            if (isNaN(amount)) {
                return "-";
            }

            var currencies = {
                USD: "$",
                EUR: "€",
                GBP: "£",
                BRL: "R$",
                JPY: "¥",
                AUD: "$",
                CHF: "Fr.",
                CAD: "$",
                HKD: "$",
                SEK: "kr.",
                NZD: "$",
                SGD: "$",
                NOK: "kr.",
                MXN: "$",
                INR: "INR.",
                PTS: "Pts.",
                IDR: "IDR.",
            };

            if (typeof amount != "undefined") {
                amount = parseFloat(amount).toFixed(2);
            }

            if (currencies.hasOwnProperty(shortcode)) {
                return currencies[shortcode] + amount;
            }

            return shortcode + " " + amount;
        };
    });

    app.filter("tapLabels", [
        "$sanitize",
        "$sce",
        function($sanitize, $sce) {
            return function(labels) {
                var output = "";
                angular.forEach(labels, function(label) {
                    output += '<div class="label-tag f-l spaced-right-small">' + EscapeHtml(label) + "</div>";
                });

                return $sce.trustAsHtml(output);
            };
        },
    ]);

    app.filter("capitalize", function() {
        return function(input) {
            return input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : "";
        };
    });

    app.filter("truncate", function() {
        return function(input, chars) {
            return input ? truncate(input, chars) : "";
        };
    });

    app.filter("unsafe", [
        "$sce",
        function($sce) {
            return function(val) {
                return $sce.trustAsHtml(val);
            };
        },
    ]);

    app.filter("numberEx", [
        "numberFilter",
        "$locale",
        function(number, $locale) {
            var formats = $locale.NUMBER_FORMATS;
            return function(input, fractionSize) {
                if (typeof input === "undefined") return;
                //Get formatted value
                var formattedValue = number(input, fractionSize);

                //get the decimalSepPosition
                var decimalIdx = formattedValue.indexOf(formats.DECIMAL_SEP);

                //If no decimal just return
                if (decimalIdx == -1) return formattedValue;

                var whole = formattedValue.substring(0, decimalIdx);
                var decimal = (Number(formattedValue.substring(decimalIdx)) || "").toString();

                return whole + decimal.substring(1);
            };
        },
    ]);

    app.filter("encodeURIComponent", function() {
        return window.encodeURIComponent;
    });
});
